import React from "react";

export function formatRelativeTime(ts) {
  if (!ts) return "—";
  const diff = Math.max(0, Date.now() - Number(ts));
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hr${hrs === 1 ? "" : "s"} ago`;
  const days = Math.floor(hrs / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}

export function formatNextSync(connector) {
  if (connector.frequency === "Manual") return "Manual";
  if (connector.enabled === false) return "—";
  const ms = connector.nextSyncInMs;
  if (ms == null) return "—";
  if (ms <= 0) return "Due now";
  const mins = Math.max(1, Math.round(ms / 60000));
  if (mins < 60) return `In ${mins} min`;
  const hrs = Math.round(mins / 60);
  return `In ${hrs} hr${hrs === 1 ? "" : "s"}`;
}

export function formatJobTime(value) {
  if (!value) return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function formatDateLong(value) {
  if (!value) return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
}

export function hostFromUrl(value, fallback = "—") {
  if (!value) return fallback;
  return String(value).replace(/^https?:\/\//i, "").replace(/\/$/, "") || fallback;
}

export function maskSecret(value) {
  if (!value) return "—";
  return "•".repeat(Math.max(12, Math.min(String(value).length, 16)));
}

export function maskId(value) {
  if (!value) return "—";
  const str = String(value);
  if (str.length <= 6) return `${str.slice(0, 2)}••••`;
  return `${str.slice(0, 5)}••••••••`;
}

export function HealthBadge({ health }) {
  const map = {
    Healthy: "bg-[#DDECC8] text-[#528416]",
    Failed: "bg-[#FCEBEB] text-[#CD0F0F]",
    Warning: "bg-[#FFF4E5] text-[#EF9F27]",
  };
  const label = health || "—";
  return (
    <span
      className={`inline-flex items-center justify-center rounded-[20px] px-[9px] py-1 text-[12px] leading-[14px] font-medium ${map[health] || "bg-[#F6F7FA] text-[#898F99]"}`}
    >
      {label}
    </span>
  );
}
